export const SESSION_SIGN_UP_SHARE_CODE_KEY = "sign-up-share-code"
export const SIGN_UP_SHARE_CODE_URL_KEY = "s-code"
export const PURCHASE_SHARE_CODE_URL_KEY = "p-code"
export const SESSION_PURCHASE_SHARE_CODE_KEY = "purchase-share-code"
